import { graphql } from '@/__generated__';
import { PopularModelFilter, PopularModelSort } from '@/__generated__/graphql';
import { usePaginatedQuery } from '@/reducers/usePaginatedQuery';

export const GetPopularModels = graphql(/* GraphQL */ `
  query PopularModels(
    $accountId: BigInt!
    $first: Int
    $after: String
    $sort: PopularModelSort
    $filter: PopularModelFilter
  ) {
    catalog(accountId: $accountId) {
      popularModels(first: $first, after: $after, sort: $sort, filter: $filter) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            environmentId
            projectId
            uniqueId
            group
            modelLayer
            access
            description
            queryUsage30d
            queryHistorySuccess
            columnCount
            healthIssues
            executeCompletedAt
          }
        }
      }
    }
  }
`);

type PopularModelProps = {
  first: number;
  after?: string;
  accountId?: number;
  sort?: Partial<PopularModelSort>;
  filter?: Partial<PopularModelFilter>;
  pause?: boolean;
};

export const usePopularModels = ({
  first,
  after,
  accountId = 0,
  pause,
  sort,
  filter,
}: PopularModelProps) => {
  const query = usePaginatedQuery(
    {
      query: GetPopularModels,
      variables: {
        first,
        after,
        accountId,
        sort,
        filter,
      },
      pause: pause || !accountId,
    },
    (data) => {
      const popularModels = data?.catalog?.popularModels;
      const pageInfo = popularModels?.pageInfo;
      if (popularModels == null || pageInfo == null) return undefined;
      return {
        totalCount: popularModels.totalCount ?? null,
        endCursor: pageInfo.endCursor ?? null,
        hasNextPage: pageInfo.hasNextPage,
      };
    },
    (data) => {
      return (data.catalog?.popularModels?.edges ?? []).map((edge) => edge.node);
    },
    () => null,
  );

  return query;
};
